import translate from '@/scripts/translate';
import { getLang } from '@/scripts/utils';

export default {
  getCurrentQuestion: (state) => {
    let currentQuestion;

    if (state.currentGame.questionsIdList.length === 0) currentQuestion = null;
    else {
      const currentKey = state.currentGame.questionsIdList[state.currentGame.questionsIndex];
      currentQuestion = {
        content: translate('questions', getLang())[currentKey],
        structure: state.questions[state.currentGame.groupIndex][currentKey],
      };
    }

    return currentQuestion;
  },
};
